import React from 'react';
import NoindexRedirect from '../shared/NoindexRedirect';

/** Legacy URL — all guide discovery now lives at /guides */
const Blogs = () => <NoindexRedirect path="/blogs" to="/guides" />;

export default Blogs;
